export const colors = {
    rare1:'radial-gradient(circle, #00FFE1 0%, #009CF3 100%);',
    rare2:'radial-gradient(circle, #AE00FF 0%, #4D00FF 100%);',
    rare3:'radial-gradient(circle, #FF9FEB 0%, #F300BF 100%);',
    rare4:'radial-gradient(circle, #FF5C33 0%, #FF0000 100%);',
    rare5:'radial-gradient(circle, #FFF81F 0%, #FFC300 100%);',
  }

export const getColorForRare = (rare?: number): string => {
    switch (rare) {
        case 1:
            return colors.rare1;
        case 2:
            return colors.rare2;
        case 3:
            return colors.rare3;
        case 4:
            return colors.rare4;
        case 5:
            return colors.rare5;
        default:
            return ''; 
    }
};

export const RARITY_COLORS: Record<number, { primary: string; secondary: string }> = {
    1: { primary: '#00FFE1', secondary: '#009CF3' },
    2: { primary: '#AE00FF', secondary: '#4D00FF' },
    3: { primary: '#FF9FEB', secondary: '#F300BF' },
    4: { primary: '#FF5C33', secondary: '#FF0000' },
    5: { primary: '#FFF81F', secondary: '#FFC300' },
};

export const getRarityColors = (rare?: number) =>
    RARITY_COLORS[rare ?? 1] || RARITY_COLORS[1];

export const MAIN_COLORS = {
    purple_100: '#1E0029',
    purple_200: '#4A0066',
    purple_300: '#6F0099',
    purple_400: '#9400CC',
    purple_500: '#B900FF',
    purple_600: '#C733FF',
    purple_700: '#D566FF',
    purple_800: '#E399FF',
    purple_900: '#F1CCFF',

    gradient_purple_100: 'linear-gradient(180deg, #1E0029 0%, #4A0066 100%)',
    gradient_purple_200: 'linear-gradient(180deg, #1E0029 20%, #6F0099 100%)',
    gradient_purple_300: 'linear-gradient(90deg, #6F0099 0%, #9400CC 100%)',
    gradient_purple_400: 'linear-gradient(90deg, #9400CC 0%, #B900FF 100%)',

    gradient_pink_100: 'linear-gradient(90deg, #330031 0%, #660061 100%)',
    gradient_pink_200: 'linear-gradient(90deg, #660061 0%, #990092 100%)',
    gradient_pink_300: 'linear-gradient(90deg, #990092 0%, #CC00C3 100%)',
    gradient_pink_400: 'linear-gradient(90deg, #660061 0%, #FF00F3 100%)',

    pink: '#FF00F3',
    yellow: '#FFED00',
    gradient_yellow_pink: 'linear-gradient(90deg, #FFED00 0%, #FF00F3 100%)',
}